import { useCallback, useEffect } from 'react';
import { Button, Card, Intent } from '@blueprintjs/core';
import { useNavigate, useParams } from 'react-router-dom';
import ReactJson from 'react-json-view';

import { getWavelightWave } from '../reducer';
import { WAVELIGHT_WAVES_TECHNIQUES } from '../routes';

import { Wave, WavelightAlgorithms } from '../../../types';
import {
  AverageOfColorsData,
  PpgExtractorData,
  WavelightsState,
} from '../types';
import { useAppDispatch, useAppSelector } from '../../../hooks';

import { WavelightsContainer } from './styles';

import Loading from '../../../components/Loading';
import AverageOfColors from '../components/AverageOfColors';
import PpgExtractor from '../components/PpgExtractor';

const WavelightsWavesItem = () => {
  const { id, wid } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { wave }: WavelightsState = useAppSelector((state) => state.wavelight);

  useEffect(() => {
    dispatch(
      getWavelightWave({
        id: id as string,
        wid: wid as string,
      }),
    );
  }, [dispatch, id, wid]);

  // Move to Techniques Screen
  const openTechniquesScreen = useCallback(() => {
    navigate(WAVELIGHT_WAVES_TECHNIQUES(id as string, wid as string));
  }, [id, wid, navigate]);

  const getWidget = (item: Wave) => {
    switch (item.algorithm) {
      case WavelightAlgorithms.AVERAGE_OF_COLORS:
        return <AverageOfColors data={item.data as AverageOfColorsData} />;
      case WavelightAlgorithms.PPG_EXTRACTOR:
        return <PpgExtractor data={item.data as PpgExtractorData} />;
    }
    return null;
  };

  if (!wave) {
    return <Loading />;
  }

  return (
    <WavelightsContainer>
      <Card>
        <div>
          <strong>Algoritmo</strong>: {wave.algorithm}
        </div>
        <div>
          <strong>Versão</strong>: {wave.version}
        </div>
        <div>
          <strong>Duração</strong>: {wave.process_time_taken}
        </div>
        <Card
          style={{
            margin: '10px',
          }}
        >
          <ReactJson src={wave.configuration} />
        </Card>
        <Button
          icon="function"
          intent={Intent.PRIMARY}
          onClick={openTechniquesScreen}
        >
          Técnicas
        </Button>
      </Card>
      <Card>{getWidget(wave)}</Card>
    </WavelightsContainer>
  );
};

export default WavelightsWavesItem;
